
import React, { useState } from "react";
import { C, RC } from "../utils/api";

export default function Equipos({equipos, user, delEq, setMapCenter, setMapZoom, setView, setForm}) {
  const [tab,setTab]=useState("naps");
  const tabs=[{id:"olts",l:"OLTs"},{id:"mufas",l:"Mufas"},{id:"naps",l:"NAPs"},{id:"fibras",l:"Fibras"}];
  const items=equipos[tab]||[];

  const goToMap=(item)=>{
    if(tab==="fibras"){
      try {
        const coords = item.coordenadas ? JSON.parse(item.coordenadas) : null;
        if(coords&&coords.length>0){
          setMapCenter({lat:parseFloat(coords[0].lat), lng:parseFloat(coords[0].lng)});
          setMapZoom(16);
          setView("mapa");
        }
      } catch(e){}
    } else {
      if(item.lat&&item.lng){
        setMapCenter({lat:parseFloat(item.lat),lng:parseFloat(item.lng)});
        setMapZoom(18);
        setView("mapa");
      }
    }
  };

  return (
    <div style={{height:"100%",overflowY:"auto",padding:"1rem"}}>
      <div style={{display:"flex",gap:6,marginBottom:16,overflowX:"auto"}}>
        {tabs.map(t=>(<div key={t.id} onClick={()=>setTab(t.id)} style={{flexShrink:0,padding:"6px 14px",borderRadius:20,fontSize:13,fontWeight:500,cursor:"pointer",background:tab===t.id?C.accent:C.white,color:tab===t.id?C.white:C.muted,border:"1px solid "+(tab===t.id?C.accent:C.border)}}>{t.l} ({(equipos[t.id]||[]).length})</div>))}
      </div>
      {items.length===0 && <p style={{color:C.muted,textAlign:"center",padding:"2rem 0"}}>No hay registros</p>}
      {items.map(item=>(
        <div key={item.id} style={{background:C.white,borderRadius:10,padding:"12px",marginBottom:10,border:"1px solid "+C.border}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div style={{flex:1}}>
              <p onClick={()=>goToMap(item)} style={{margin:"0 0 4px",fontWeight:600,fontSize:14,cursor:"pointer",color:C.accent,textDecoration:"underline"}}>{item.nombre}</p>
              <p style={{margin:"0 0 4px",fontSize:12,color:C.muted}}>
                {tab==="naps" && ((item.puertos_ocupados||0)+"/"+item.puertos+" puertos - "+item.tipo_splitter)}
                {tab==="mufas" && (item.tipo_instalacion+" - "+(item.olt_nombre||"Sin OLT"))}
                {tab==="olts" && ((item.marca||"")+" "+(item.modelo||"")+" - "+item.puertos_pon+" PON")}
                {tab==="fibras" && (item.tipo_hilos+" hilos - "+item.tipo_instalacion+" - "+(item.longitud_metros||"?")+"m")}
              </p>
              <span style={{fontSize:11,padding:"2px 8px",borderRadius:99,background:item.estado==="activo"?"#D1FAE5":"#FEE2E2",color:item.estado==="activo"?"#065F46":"#991B1B"}}>{item.estado}</span>
            </div>
            <div style={{display:"flex",gap:6,marginLeft:8}}>
              {RC.includes(user.rol) && tab!=="fibras" && <button onClick={()=>setForm({tipo:tab.slice(0,-1),edit:item})} style={{padding:"4px 8px",background:"#1E7BBF",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"pointer"}}>Editar</button>}
              {RC.includes(user.rol) && <button onClick={()=>delEq(tab.slice(0,-1),item.id)} style={{padding:"4px 8px",background:"#FEE2E2",color:"#991B1B",border:"none",borderRadius:6,fontSize:11,cursor:"pointer"}}>X</button>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
